module.exports = __webpack_public_path__ + "img/bg-move.71207c4a.jpg";